window.skSocial = function () {
    function publicGetFacebookShareUrl(url) {
        popitup('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), 'facebook');
    }
    function publicGetTwitterShareUrl(url, tweet_copy) {
        // https://x.com/intent/post?text=Commemorating%20the%2080th%20Anniversary%20of%20Hiroshima%20Day%20in%20the%20Japanese%20Tea%20Garden&url=https%3A%2F%2Fgggp.org%2Fcommemorating-hiroshima-day%2F
        popitup('https://x.com/intent/post?text=' + encodeURIComponent(tweet_copy) + ' ' + encodeURIComponent(url), 'x');
        // popitup('https://twitter.com/home?status=' + encodeURIComponent(tweet_copy) + '%20' + encodeURIComponent(url), 'twitter');
    }
    function publicGetLinkedinShareUrl(url, title, summary, source) {
        popitup('https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(url), 'linkedin');
    }
    function publicGetGooglePlusShareUrl(url) {
        popitup('https://plus.google.com/share?url=' + encodeURIComponent(url));
    }
    function publicGetEmailShareLink(url) {
        window.location = "mailto:?subject=SIMOS is Hiring!&body=Check out this job from SIMOS. I think you would be interested. Apply online at " + url;
        // return "mailto:?subject=Veridian&body=Check out this site " + url;
    }
    function popitup(url, share_site) {
        var dimensions = '';
        if (share_site === 'facebook' || share_site === 'linkedin') {
            dimensions = 'height=640,width=555';
        } else if (share_site === 'x' || share_site === 'twitter') {
            dimensions = 'height=280,width=550';
        }
        var newwindow = window.open(url, 'name', dimensions);
        if (window.focus) {
            newwindow.focus();
        }
        return false;
    }
    return {
        getFacebookShareUrl: publicGetFacebookShareUrl,
        getTwitterShareUrl: publicGetTwitterShareUrl,
        getLinkedInShareUrl: publicGetLinkedinShareUrl,
        getGooglePlusShareUrl: publicGetGooglePlusShareUrl,
        getEmailShare: publicGetEmailShareLink
    };
}();
;'use strict';

$('.mobile-share-job-button').on('click', function () {
    if (navigator.share) {
        navigator.share({
            title: $(this).data('title'),
            url: $(this).data('url')
        }).then(() => console.log('Shared!'))
            .catch(console.error);
    }
});

if(!navigator.share) {
    $('.mobile-share-job-button').remove();
}
